export default __webpack_public_path__ + "5160a7dfcffbefaca64176bab60b57b5.png";